import CardBuilderMessages from '../lib/CardBuilder/i18n/messages';
import NotesMessages from '../lib/Notes/i18n/messages';

export default {
  en: {
    ...CardBuilderMessages.en,
    ...NotesMessages.en,
  },
};
